import { IconWrapper } from '../runtime';
export default IconWrapper('form-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + '376d23fd' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.8594 5.25C13.453 5.25 13.0781 5.46922 12.8789 5.82346L11.0921 9H6.95869C6.55856 9 6.18855 9.21253 5.98694 9.55815L5.32899 10.686C5.18316 10.936 5.36349 11.25 5.65291 11.25H11.75C12.1565 11.25 12.5313 11.0308 12.7305 10.6765L14.5173 7.5H17V16.5H8.00002V12.75H5.75002V17.625C5.75002 18.2463 6.2537 18.75 6.87502 18.75H18.125C18.7463 18.75 19.25 18.2463 19.25 17.625V6.375C19.25 5.75368 18.7463 5.25 18.125 5.25H13.8594ZM7.80916 7.5H10.158L11.4671 5.25H9.11494C8.71481 5.25 8.3448 5.46253 8.14319 5.80815L7.48524 6.93605C7.33941 7.18605 7.51974 7.5 7.80916 7.5Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '376d23fd',
      "x1": "24.5",
      "y1": "24",
      "x2": "0.5",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0.029618",
      "stop-color": "#0A6CFF"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#29A9FF"
    }
  })])])]);
});